/* =========================================================
   PROGRAMS
========================================================= */
import React from "react";

import SectionHeader from "./SectionHeader";

const ProgramsSection = ({ data }) => (
    <section id="programs">

        <div className="container">

            <SectionHeader
                title={data.title}
                description={data.description}
            />

            <div className="program-grid">

                {(data.items || []).map((item, i) => (
                    <div className="program-card" key={i}>

                        <div className="program-number">
                            PROGRAM {String(i + 1).padStart(2, "0")}
                        </div>

                        <div className="program-icon">
                            {item.icon}
                        </div>

                        <h3>{item.title}</h3>

                        <p>{item.description}</p>

                        <a
                            href={item.url || "#"}
                            className="learn-more"
                        >
                            {item.linkText || "Explore program →"}
                        </a>

                    </div>
                ))}

            </div>

        </div>

    </section>
);

export default ProgramsSection;